module.exports = __webpack_public_path__ + "img/pyramid-one.96675e8d.svg";